// Utility helpers for category behaviors across the app

const SYSTEM_CATEGORY_LABELS = ['Sortie Coffre', 'Rapprochement Ajout', 'Rapprochement Déduction'];

// Supports both Category and CategoryDetail structures
export function isSystemCategory(categoryOrDetail) {
  if (!categoryOrDetail) return false;
  const label = (categoryOrDetail.category?.label || categoryOrDetail.label || '').trim();
  return SYSTEM_CATEGORY_LABELS.includes(label)
    || (Number(categoryOrDetail.caisseFactor) === 0 && Number(categoryOrDetail.coffreFactor) === -1);
}



